<template>
    <v-hover v-slot:default="{ hover }">
        <v-btn :class="[hover ? local_style.classHover : local_style.class, local_is_loading ? 'isLoading' : '', local_only_icon ? 'only-icon' : '' ]"
               :color="local_style.color"
               :height="local_is_square ? 40 : local_style.height"
               :width="local_only_icon ? 40 : ''"
               :min-width="local_only_icon ? 40 : ''"
               :block="local_is_block"
               :disabled="local_is_disabled"
               :text="local_style.isText"
               :href="local_href"
               elevation="0"
               :type="local_button_type"
               v-ripple="{ class: 'ripple-black' }"
               @click="onClick">
            <span v-if="!local_only_text" :class="['icon-container', local_is_tiny_icon ? 'tiny' : '']">
                <i :class="local_icon"></i>
                <v-progress-circular class="loader"
                                     :indeterminate="true"
                                     :rotate="0"
                                     :size="16"
                                     :value="0"
                                     :width="2"
                                     color="#2e3a46">
                </v-progress-circular>
            </span>
            <span :class="['text', local_only_icon ? 'd-none' : '']">{{local_text}}</span>
        </v-btn>
    </v-hover>
</template>
<script>
    export default {
        props: {
            data_text: String,              // Sets the text on button
            data_type: String,              // Sets the button type to give him diferents styles. See in avocode the match, they are in order.
            data_icon: String,              // Sets the button icon
            data_href: String,              // Sets the link for the button
            data_is_disabled: Boolean,      // Sets if button is disabled
            data_is_loading: Boolean,       // If is loading should be true
            data_only_icon: Boolean,        // For buttons that have only the icon
            data_is_block: Boolean,         // Sets if the width is 100%
            data_is_tiny_icon: Boolean,     // Sets if icon is small
            data_only_text: Boolean,        // For buttons that have only text.
            data_button_type: String,       // Sets the button type.
            data_is_square: Boolean
        },
        data() {
            return {
                local_text: this.data_text,
                local_icon: this.data_icon,
                local_is_block: this.data_is_block != null ? this.data_is_block : false,
                local_only_icon: this.data_only_icon != null ? this.data_only_icon : false,
                local_only_text: this.setOnlyText(),
                local_is_loading: this.data_is_loading != null ? this.data_is_loading : false,
                local_is_disabled: this.setDisabled(),
                local_href: this.data_href,
                local_is_tiny_icon: this.data_is_tiny_icon != null ? this.data_is_tiny_icon : false,
                local_is_square: this.data_is_square != null ? this.data_is_square : false,
                local_button_type: this.data_button_type != null ? this.data_button_type : "button",
                local_style: {
                    color: "",
                    height: "40",
                    class: "",
                    classHover: "",
                    isText: false
                }
            }
        },
        methods: {
            setDisabled() {
                if ((this.data_is_disabled != null && this.data_is_disabled) || (this.data_is_loading != null && this.data_is_loading)) { return true; }
                return false;
            },
            setOnlyText() {
                if ((this.data_only_text != null && this.data_only_text) || this.data_icon == null || this.data_icon == "") { return true; }
                return false;
            },
            onClick(value) {
                this.$emit('click', value);
            }
        },
        beforeMount() {
            switch (this.data_type) {
                case 'button-1':
                    this.local_style.class = "btn-base button-1"
                    this.local_style.classHover = "btn-base button-1 hover"
                    break;
                case 'button-2':
                    this.local_style.color = "#1e9d8b";
                    this.local_style.class = "btn-base button-2"
                    this.local_style.classHover = "btn-base button-2 hover"
                    break;
                case 'button-3':
                    this.local_style.color = "#28323b";
                    this.local_style.class = "btn-base button-3"
                    this.local_style.classHover = "btn-base button-3 hover"
                    break;
                case 'button-4':
                    this.local_style.color = "#28323b";
                    this.local_style.class = "btn-base button-4"
                    this.local_style.classHover = "btn-base button-4 hover"
                    break;
                case 'button-5':
                    this.local_style.color = "#2e3a46";
                    this.local_style.class = "btn-base button-5"
                    this.local_style.classHover = "btn-base button-5 hover"
                    this.local_style.isBlock = true;
                    break;
                case 'button-6':
                    this.local_style.color = "#ecedef";
                    this.local_style.class = "btn-base button-6"
                    this.local_style.classHover = "btn-base button-6 hover"
                    break;
                case 'button-7':
                    this.local_style.color = "#d9dce0";
                    this.local_style.class = "btn-base button-7"
                    this.local_style.classHover = "btn-base button-7 hover"
                    break;
                case 'button-8':
                    this.local_style.color = "#d9dce0";
                    this.local_style.class = "btn-base button-8"
                    this.local_style.classHover = "btn-base button-8 hover"
                    break;
                case 'button-9':
                    this.local_style.height = "32";
                    this.local_style.color = "#ecedef";
                    this.local_style.class = "btn-base button-9"
                    this.local_style.classHover = "btn-base button-9 hover"
                    break;
                case 'button-10':
                    this.local_style.height = "32";
                    this.local_style.color = "#ecedef";
                    this.local_style.class = "btn-base button-10"
                    this.local_style.classHover = "btn-base button-10 hover"
                    this.local_style.isText = true
                    break;
                case 'button-11':
                    this.local_style.height = "32";
                    this.local_style.color = "#ecedef";
                    this.local_style.class = "btn-base button-11"
                    this.local_style.classHover = "btn-base button-11 hover"
                    this.local_style.isText = true
                    break;
                case 'button-archive':
                    this.local_style.color = "#28323b";
                    this.local_style.class = "btn-base button-archive"
                    this.local_style.classHover = "btn-base button-archive hover"
                    break;
                case 'button-remove':
                    this.local_style.color = "#ecedef";
                    this.local_style.class = "btn-base button-remove"
                    this.local_style.classHover = "btn-base button-remove hover"
                    break
            }
        },
        watch: {
            local_is_loading: function () {
                if (this.local_is_loading) {
                    this.local_is_disabled = true;
                }
                else {
                    this.local_is_disabled = false;
                }
            },
            data_is_disabled: function () {
                this.local_is_disabled = this.data_is_disabled;
            },
            data_text: function () {
                this.local_text = this.data_text;
            },
            data_icon: function () {
                this.local_icon = this.data_icon;
            },
            data_href: function () {
                this.local_href = this.data_href;
            },
        }
    }
</script>
